import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './DriverModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import personImg from '../../assets/images/person-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import saveImg from '../../assets/images/save-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';

class DriverModal extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraAction = null,
    extraClass = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraAction: extraAction,
      extraClass: extraClass,
      touched: false,
      errorMessage: null
    });
  }

  state = {
    localCard: null,
    loading: false,
    driverForm: {
      name: this.createInputConfig(
        'input',
        {

        },
        'ПІБ водія: ',
        '',
        { required: true },
        false),
      phone: this.createInputConfig(
        'input',
        {

        },
        'Телефон: ',
        '',
        { required: true },
        false),
      identification: this.createInputConfig(
        'input',
        {

        },
        'Номер та серія посвідчення водія: ',
        '',
        { required: true },
        false),
      comment: this.createInputConfig(
        'textarea',
        {
          rows: 3,
          display: "none"
        },
        'Коментар: ',
        '',
        { required: true },
        false),
    }
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim !== '' && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type == 'confirmPassword') {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.driver && this.props.driver) {
      const updatedForm = { ...this.state.driverForm };
      updatedForm.name.value = this.props.driver.name;
      updatedForm.phone.value = this.props.driver.phone;
      updatedForm.identification.value = this.props.driver.license;
      updatedForm.comment.value = this.props.driver.comment;
      updatedForm.comment.elementConfig.display = undefined;
      this.setState({ driverForm: updatedForm, updating: true });
    } else if (prevProps.driver && !this.props.driver) {
      const updatedForm = { ...this.state.driverForm };
      updatedForm.name.value = "";
      updatedForm.phone.value = "";
      updatedForm.identification.value = "";
      updatedForm.comment.value = "";
      updatedForm.comment.elementConfig.display = "none";
      this.setState({ driverForm: updatedForm, updating: false });
    }
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть правильний email';
      }
    }

    if (rules.type == 'confirmPassword' && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.driverForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedOrderForm[elementId] = updatedFormElement;
    const updatedCard = { ...this.state.localCard };
    updatedCard[elementId] = event.target.value;
    this.setState({ driverForm: updatedOrderForm, localCard: updatedCard });
  }

  createNewDriver = () => {
    const driverData = { ...this.state.driverForm };
    axios({
      method: 'post',
      url: '/api/v1/drivers/new',
      data: {
        name: driverData.name.value,
        phone: driverData.phone.value,
        identification: driverData.identification.value
      },
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        if (response && response.data) {
          if (this.props.drivers && this.props.drivers.length > 2) {
            const updatedDrivers = [...this.props.drivers];
            updatedDrivers.push({
              id: response.data,
              name: driverData.name.value,
              phone: driverData.phone.value
            });
            this.props.onSetDrivers(updatedDrivers);
          }
        }
        const updatedForm = { ...this.state.driverForm };
        updatedForm.name.value = "";
        updatedForm.phone.value = "";
        updatedForm.identification.value = "";
        updatedForm.comment.value = "";
        this.props.addNotification("Водій успішно створений", "Success");
        this.props.onShowDriverForm(false, null);
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/drivers/new'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  updateDriver = () => {
    const driverData = { ...this.state.driverForm };
    axios({
      method: 'post',
      url: '/api/v1/drivers/update',
      data: {
        id: this.props.driver.id,
        name: driverData.name.value,
        phone: driverData.phone.value,
        license: driverData.identification.value,
        comment: driverData.comment.value
      },
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        if (response && response.data) {
          const updatedDrivers = [...this.props.drivers];
          for (let i = 0; i < updatedDrivers.length; i++) {
            if (updatedDrivers[i].id === response.data.id) {
              updatedDrivers[i] = response.data;
              break;
            }
          }
          this.props.onSetDrivers(updatedDrivers);
        }
        const updatedForm = { ...this.state.driverForm };
        updatedForm.name.value = "";
        updatedForm.phone.value = "";
        updatedForm.identification.value = "";
        updatedForm.comment.value = "";
        this.props.addNotification("Водій успішно оновлений", "Success");
        this.props.onShowDriverForm(false, null);
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/drivers/new'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  render() {
    let card = null;
    if (this.props.showDriverForm) {
      const driverFormArray = [];
      for (let key in this.state.driverForm) {
        driverFormArray.push({ id: key, config: this.state.driverForm[key] });
      }

      let loading = null;
      if (this.state.loading) {
        loading = (
          <Spinner />
        )
      }

      let headerClasses = [classes.Header];
      headerClasses.push(classes.HeaderWhite);

      card = (
        <Aux>
          <div className={headerClasses.join(' ')}>

            <div className={classes.CarrierTitle}>
              <Icon iconClass={classes.CarIcon} iconSource={personImg} iconAlt='' className={classes.CardIcon} />
              {this.state.updating ? "Оновлення Водія" : "Новий Водій"}
            </div>

            <button className={classes.CloseButton} onClick={(ev) => this.props.onShowDriverForm(false, null)}>
              <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
            </button>
            <p style={{ height: "100%" }}></p>
          </div>

          <div className={classes.Body} >
            {loading}
            {driverFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}
          </div>

          {loading}

          <div className={classes.Footer}>
            <div className={classes.FooterButtons}>
              {
                this.state.updating ?
                  <ButtonIcon
                    btnType='Success'
                    clicked={(ev) => this.updateDriver(ev)}
                    disabled={this.state.loading}
                    iconClass={classes.ButtonIcon}
                    iconSource={saveImg}
                    small
                    iconAlt=''>ОНОВИТИ</ButtonIcon>
                  :
                  <ButtonIcon
                    btnType='Success'
                    clicked={(ev) => this.createNewDriver(ev)}
                    disabled={this.state.loading}
                    iconClass={classes.ButtonIcon}
                    iconSource={saveImg}
                    small
                    iconAlt=''>СТВОРИТИ</ButtonIcon>
              }
            </div>
          </div>
        </Aux>
      );
    }

    let carrierClass = classes.CardModal;

    return (
      <Aux>
        <div
          className={carrierClass}
          style={{
            transform: this.props.showDriverForm ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: this.props.showDriverForm ? '1' : '0'
          }}>
          {this.props.showDriverForm && card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    drivers: state.drivers,
    showDriverForm: state.showDriverForm,
    codeToMessage: state.codeToMessage,
    driver: state.driver
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetDrivers: (drivers) => dispatch({
      type: actionTypes.SET_DRIVERS,
      drivers: drivers
    }),
    onShowDriverForm: (showDriverForm, driver) => dispatch({
      type: actionTypes.SHOW_DRIVER_FORM,
      showDriverForm: showDriverForm,
      driver: driver
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverModal);



// WEBPACK FOOTER //
// ./src/components/DriverModal/DriverModal.js